"use client"

import { Fragment, type PropsWithChildren } from "react"
import { useSearchParams } from "next/navigation"

import { CHECKOUT_URL } from "~/lib/shopify/constants"
import useAuthentication from "~/hooks/account/useAuthentication"
import { LoadingPage } from "~/components/ui/LoadingPage"
import { useInternalRedirects } from "~/providers/InternalRedirectsProvider/index.client"

export function WithoutAuthentication({ children }: PropsWithChildren) {
  const searchParams = useSearchParams()
  const redirectUrl = searchParams.get("redirectUrl")
  const [redirects] = useInternalRedirects()
  const checkoutUrlSearchParams = searchParams.get("checkout_url")
  // if user is logged in, redirect to the main account page
  const { isInitialLoading, data: customer } = useAuthentication(
    undefined,
    checkoutUrlSearchParams
      ? `https://${CHECKOUT_URL}${checkoutUrlSearchParams}`
      : (redirectUrl as string) || redirects?.accountHome?.href
  )

  if (customer || isInitialLoading) {
    return <LoadingPage />
  }

  return <Fragment>{children}</Fragment>
}
